import { render } from "./AutomatedChecksManager.vue?vue&type=template&id=1b3056bc&scoped=true"
import script from "./AutomatedChecksManager.vue?vue&type=script&lang=js"
export * from "./AutomatedChecksManager.vue?vue&type=script&lang=js"

import "./AutomatedChecksManager.vue?vue&type=style&index=0&id=1b3056bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3056bc"]])

export default __exports__